module.exports = __webpack_public_path__ + "img/42.b0b3176d.jpg";